import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsConstant } from 'commons-vehicle/PurchaseMethods/index.js';

import 'commons-vehicle/Vehicle/components/PaymentOptionFilters/MethodButton/MethodButton.scss';

class MethodButton extends React.Component {
    constructor(props) {
        super(props);

        const isFinance = this.props.currentMethod === PurchaseMethodsConstant.FINANCE;
        const isLease = this.props.currentMethod === PurchaseMethodsConstant.LEASE;
        const isPayCash = this.props.currentMethod === PurchaseMethodsConstant.CASH;

        this.state = {
            paymentMethod: {
                finance: {
                    value: PurchaseMethodsConstant.FINANCE,
                    translation: 'METHOD_PAYMENT.FINANCE',
                    current: isFinance,
                },
                lease: {
                    value: PurchaseMethodsConstant.LEASE,
                    translation: 'METHOD_PAYMENT.LEASE',
                    current: isLease,
                },
                payCash: {
                    value: PurchaseMethodsConstant.CASH,
                    translation: 'METHOD_PAYMENT.PAY_CASH',
                    current: isPayCash,
                },
            },
        };

        this.changePayment = this.changePayment.bind(this);
        this.updateCurrentMethod = this.updateCurrentMethod.bind(this);
    }

    componentWillMount() {
        if (!this.props.hasLease) {
            const isFinance = this.props.currentMethod === PurchaseMethodsConstant.FINANCE;
            const isPayCash = this.props.currentMethod === PurchaseMethodsConstant.CASH;
            const newMethod = {
                finance: {
                    value: PurchaseMethodsConstant.FINANCE,
                    translation: 'METHOD_PAYMENT.FINANCE',
                    current: isFinance,
                },
                payCash: {
                    value: PurchaseMethodsConstant.CASH,
                    translation: 'METHOD_PAYMENT.PAY_CASH',
                    current: isPayCash,
                },
            };
            this.setState({
                paymentMethod: newMethod,
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (!newProps.currentMethod) {
            return;
        }

        this.updateCurrentMethod(newProps.currentMethod);
    }

    updateCurrentMethod(payment) {
        const paymentMethod = { ...this.state.paymentMethod };

        Object.keys(this.state.paymentMethod).forEach((method) => {
            paymentMethod[method].current = false;
            if (this.state.paymentMethod[method].value === payment) {
                paymentMethod[method].current = true;
            }
        });

        this.setState({ paymentMethod });
    }

    changePayment(e) {
        const payment = e.target.value;

        this.updateCurrentMethod(payment);
        this.props.selectPreferredPurchaseMethod(payment);
        this.props.onSelection(payment);
    }

    render() {
        const payment = this.state.paymentMethod;

        const buttons = map(payment, (currentButton) => (
            <button
                key={currentButton.value}
                onClick={(e) => this.changePayment(e)}
                value={currentButton.value}
                className={currentButton.current ? 'current' : ''}
            >
                {LocaleService.t(currentButton.translation)}
            </button>
        ));

        return <div className="method-button-payment-bar">{buttons}</div>;
    }
}

MethodButton.defaultProps = {
    hasLease: false,
};

MethodButton.propTypes = {
    currentMethod: PropTypes.string.isRequired,
    hasLease: PropTypes.bool,
    onSelection: PropTypes.func.isRequired,
    selectPreferredPurchaseMethod: PropTypes.func.isRequired,
};

MethodButton.displayName = 'MethodButton';

export default MethodButton;
